import { render, staticRenderFns } from "./NotificationEmptyState.vue?vue&type=template&id=50a5e8df&scoped=true&"
import script from "./NotificationEmptyState.vue?vue&type=script&lang=js&"
export * from "./NotificationEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEmptyState.vue?vue&type=style&index=0&id=50a5e8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5e8df",
  null
  
)

export default component.exports